import { Entry } from '../Entry'

export function Entry20261005() {
  return (
    <Entry title="2026 Oct 5 - v3.11.20">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27227/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
